<template>
	<!-- <f7-page class=""> -->
  <div class="page">
    <bottom-toolbar></bottom-toolbar>
    <div class="page-content">
  		<div class="layoutTop"/>
      <div class="container-fluid">

      <div class="row">
        <div class="offset-md-1 col-md-10">
          <div class="panel21 panel-default">

            <div class="panel-heading">
                <h4 class="content-block labelAccordionForm">
                    <i class="fa fa-address-book formIcon"></i>
                    {{ $t('common.item_details',
                      {itemname: $t(this.$engine.services.getLabelIdOne(this.$engine.user.currentService.id))}) }}
                </h4>
            </div>

            <form>
              <div class="form-group row">
                <label class="col-5 col-sm-2 col-form-label">Type</label>
                <div class="col-7 col-sm-10">
                  <input class="form-control" type="text" v-model="typeContact" disabled></input>
                </div>
              </div>
              <div class="form-group row">
                <label class="col-5 col-sm-2 col-form-label">Name</label>
                <div class="col-7 col-sm-10">
                  <input class="form-control" type="text" v-model="username" disabled></input>
                </div>
              </div>
              <div class="form-group row">
                <label class="col-5 col-sm-2 col-form-label">Alias</label>
                <div class="col-7 col-sm-10">
                  <input class="form-control" type="text" v-model="label" disabled></input>
                </div>
              </div>
              <div class="form-group row" v-if="this.$settings.currentContact.typeContact === '1'">
                <label class="col-5 col-sm-2 col-form-label">Email</label>
                <div class="col-7 col-sm-10">
                  <input class="form-control" type="text" v-model="identifier" disabled></input>
                </div>
              </div>
              <div class="form-group row" v-if="this.$settings.currentContact.typeContact === '2'">
                <label class="col-5 col-sm-2 col-form-label">SIREN</label>
                <div class="col-7 col-sm-10">
                  <input class="form-control" type="text" v-model="identifier" disabled></input>
                </div>
              </div>

              <div
                class="form-group row"
                v-for="bankData in extractedBankData">
                <label class="col-5 col-sm-2 col-form-label">{{ $t(bankData.labelId) }}</label>
                  <div class="col-7 col-sm-10">
                    <input class="form-control" type="text" v-model="bankData.value" disabled></input>
                  </div>
              </div>


              <div v-if="this.$engine.user.currentService.id === '2'">
                <div class="form-group row">
                  <label class="col-4 col-sm-2 col-form-label">{{ $t('bank_accounts.mandat_id') }}</label>
                  <div class="col-8 col-sm-10">
                    <input name="mandatId" class="form-control" type="text" :placeholder="$i18n.t('bank_accounts.mandat_id')" disabled></input>
                  </div>
                </div>
                <div class="form-group row">
                  <label class="col-sm-2 col-4 col-form-label labelAccordionForm">
                    {{ $t('bank_accounts.mandat_date') }}
                  </label>
                  <div class="col-8 col-sm-10">
                    <input class="form-control" type="date" :placeholder="$i18n.t('bank_accounts.mandat_date')" disabled>
                  </div>
                </div>
              </div>
              <div class="form-group row">
                <label class="col-5 col-sm-2 col-form-label">Phone Number</label>
                <div class="col-7 col-sm-10">
                  <input class="form-control" type="text" v-model="phoneNumber" disabled></input>
                </div>
              </div>
              <div class="form-group row">
                <label class="col-5 col-sm-2 col-form-label">Adress</label>
                <div class="col-7 col-sm-10">
                  <input class="form-control" type="text" v-model="address" disabled></input>
                </div>
              </div>
              <div class="form-group row">
                <label class="col-5 col-sm-2 col-form-label">City</label>
                <div class="col-7 col-sm-10">
                  <input class="form-control" type="text" v-model="city" disabled></input>
                </div>
              </div>
              <div class="form-group row">
                <label class="col-5 col-sm-2 col-form-label">Zip Code</label>
                <div class="col-7 col-sm-10">
                  <input class="form-control" type="text" v-model="zipCode" disabled></input>
                </div>
              </div>
              <div class="form-group row">
                <label class="col-5 col-sm-2 col-form-label">Country</label>
                <div class="col-7 col-sm-10">
                  <input class="form-control" type="text" v-model="country" disabled></input>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
      <div class="row justify-content-start" :class="colorBottomButton">
        <div class="offset-md-5 col-md-3">
          <a href="/account/editContact/" style="color: #000;">
            <button round class="button-action ">
              <f7-icon f7='edit'></f7-icon>
              <span>
                {{ $t('common.edit_item',
                  {itemname: $t(this.$engine.services.getLabelIdOne(this.$engine.user.currentService.id))}) }}</span>
            </button>
          </a>
        </div>
        <div class="col-md-3">
          <button round
            class="button-action "
            title="Remove"
            @click="removeContact">
              <f7-icon f7='close_round_fill'></f7-icon>
            <span>Remove</span>
          </button>
        </div>
      </div>
  </div>

      <div class="toolbarPageBottomBlank"></div>
    </div>
  </div>
	<!-- </f7-page> -->
</template>

<script>
import {extractForeignIban} from '@/helpers/format'
import pageNavBar from '@/components/common/pageNavBar.vue'
import bottomToolbar from '@/components/bottomToolbar/bottomToolbar.vue'
import {loadPage} from '@/helpers/routing'

export default {
  components: {
    'page-nav-bar': pageNavBar,
    'bottom-toolbar': bottomToolbar
  },
  data () {
    return {
      colorBottomButton: this.$engine.services.getButtonClassColorById(this.$engine.user.currentService.id),
      id: '',
      identifier: '',
      username: '',
      extractedBankData: {},
      label: '',
      phoneNumber: '',
      address: '',
      city: '',
      zipCode: '',
      country: '',
      typeContact: '',
      zone: '',
      accountLabel: {}
    }
  },
  created () {
    this.id = this.$settings.currentContact.id
    this.username = this.$settings.currentContact.name
    this.identifier = this.$settings.currentContact.identifier
    this.label = this.$settings.currentContact.label
    this.phoneNumber = this.$settings.currentContact.phoneNumber
    this.typeContact = (this.$settings.currentContact.typeContact === '1' ? 'Individual' : 'Company')
    this.address = this.$settings.currentContact.address
    this.city = this.$settings.currentContact.city
    this.zipCode = this.$settings.currentContact.zipCode
    this.country = this.$settings.currentContact.country
    this.zone = this.$settings.currentContact.zoneCode
    this.accountLabel = this.$engine.bankAccounts.getAccountLabel(this.zone)

    if (this.$settings.currentContact.iban !== '' && this.zone !== '') {
      this.extractedBankData = extractForeignIban(this.$settings.currentContact.iban, this.zone)
    }
  },
  methods: {
    removeContact () {
      let that = this
      that.$f7.confirm('Are you sure to delete this contact?', 'Operation confirmation', function () {
        that.$engine.contacts
        .delete(that.$settings.currentContact.id)
        .then(resp => {
          that.$f7.modal({
            title: 'Contact deleted',
            text: '<span class="preloader"></span>'
          })
          setTimeout(function () {
            that.identifier = ''
            that.username = ''
            that.$f7.closeModal()
            that.$bus.$emit('refresh-cache-contacts')
            loadPage(that, {url: '/contacts/', force: false, ignoreCache: false})
          }, 2000)
        })
        .catch(err => {
          this.handleError(err) // mixins errorHandlerMixins
        })
      })
    },
    hideBlock ($event) {
      let that = this
      if (that.Dom7($event.target).hasClass('email')) {
        if (that.Dom7($event.target).next().css('display') === 'none') {
          that.Dom7($event.target).next().show()
        } else {
          that.Dom7($event.target).next().hide()
        }
      } else {
        if (that.Dom7($event.target).parent().next().css('display') === 'none') {
          that.Dom7($event.target).parent().next().show()
        } else {
          that.Dom7($event.target).parent().next().hide()
        }
      }
    }
  }
}
</script>

<style scoped>
@media (max-width: 992px) {
}
.container {
    /* margin-right: auto;
    margin-left: auto; */
    width: 100%;
    /* margin: 0 auto; */
}
.panel2, .panel21 {
    background: #fcfcfc;
    border: solid 1px #dbdbdb;
    /*margin-bottom: 5%;*/
    padding-bottom: 25px;
    padding-top: 10px;
    padding-left: 20px;
    padding-right: 20px;
    float: left;
    width: 100%;
}
* {
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
}
.orangeConfirmationButton {
  margin-top: 10%;
}

@media (max-width:  768px) {
  .col-md-3 {
    margin-top: -20px;
  }
}
</style>



// WEBPACK FOOTER //
// CMContactDetail.vue?1c5b05e8